import React, { useEffect } from 'react';
import './argos.less';
import Footer from "../../../components/Footer/Footer";
import { useScrollHeader } from '../../../hooks';

function Argos({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return (
    <div className="Argos">
      <div className='Argos_cover'>
        {/* PC端 */}
        <div className='Argos_cover-Pc'>
          <img
            className="Argos_cover-bgi2"
            src='./images/argos/argos-banner2-390.png'
            alt=''
          />
          <img
            className="Argos_cover-bgi3"
            src='./images/argos/argos-banner3-390.png'
            alt=''
          />
          <div className="Argos_cover-content pageMargin">
            <img
              className="Argos_cover-logo"
              src='./images/argos/argos-logo.svg'
              alt=''
            />
            <div className="fz_48 fw_700 lh_56 mt_60">全功能3D近视训练仪</div>
            {/* <div className="fz_24 fw_500 lh_28 c_23253B mt_5">首个调控空间频率的近视防控产品</div> */}
            <div className="fz_24 fw_500 lh_28 c_23253B mt_5">调控空间频率的近视防控产品</div>
          </div>
        </div>
        {/* 移动端 */}
        <div className="Argos_cover-Mobile flex_col flex_jc-sb">
          <div className='pageMargin flex_col flex_ai-c'>
            <img
              className='mt_100'
              style={{ width: '176px' }}
              src='./images/argos/argos-logo.svg'
              alt=''
            />
            <div className="fz_32 fw_700 lh_38 mt_40">全功能3D近视训练仪</div>
            {/* <div className="fz_14 fw_500 lh_16 c_23253B mt_10">首个调控空间频率的近视防控产品</div> */}
            <div className="fz_14 fw_500 lh_16 c_23253B mt_10">调控空间频率的近视防控产品</div>
          </div>
          <div>
            <img
              className="Argos_cover-bgi2 mt_40"
              src='./images/argos/argos-banner2-390.png'
              alt=''
            />
            <img
              className="Argos_cover-bgi3 mt_N40"
              src='./images/argos/argos-banner3-390.png'
              alt=''
            />
          </div>
        </div>
      </div>
      <div className='Argos_section1'>
        <div className="Argos_section1-content">
          <div className="Argos_section1-title linear-gradient-tr">3大功能眼脑协同全方位近视防控</div>
          <div className="Argos_section1-contentImgPc">
            <img
              style={{ width: '100%' }}
              src='./images/argos/yanqiu-1080.png'
              alt=''
            />
          </div>
          <div className="Argos_section1-contentImgMobile">
            <img
              style={{ width: '100%' }}
              src='./images/argos/yanqiu-390.png'
              alt=''
            />
          </div>
        </div>
        <div className="Argos_section1-img flex_col flex_jc-c">
          <img
            style={{ width: '100%' }}
            src='./images/argos/argos-model.png'
            alt=''
          />
        </div>
      </div>
      <div className="Argos_section2">
        <div className="Argos_section2-content pageMargin">
          <div className="Argos_section2-title linear-gradient-tr">眼脑协同<br />进一步强化近视防控效果</div>
          <div className="Argos_section2-bottom">
            <div className="Argos_section2-img">
              <img
                style={{ width: '100%' }}
                src='./images/argos/section2-1.png'
                alt=''
              />
            </div>
            <div className='Argos_section2-contentImg'>
              <img
                style={{ width: '100%' }}
                src='./images/argos/up.png'
                alt=''
              />
            </div>
            <div className="Argos_section2-img">
              <img
                style={{ width: '100%' }}
                src='./images/argos/section2-2.png'
                alt=''
              />
            </div>
          </div>
        </div>
      </div>
      <div className="Argos_section3">
        <div className='Argos_section3-top'>
          <div className='Argos_section3-topLeft' >
            <div className="Argos_section3-title linear-gradient-tr" style={{ position: 'relative' }}>集视医疗率先将空间频率理论 引入到近视防控</div>
            <div className="Argos_section3-contentItem">
              <div className='Argos_section3-contentItemBlock flex_row flex_ai-c'>
                <img
                  className='Argos_section3-itemIcon'
                  src='./images/argos/argos1_icon_white.png'
                  alt=''
                />
                <div className="Argos_section3-btnText">高频增强</div>
              </div>
            </div>
            <div className="Argos_section3-itemDesc">强化日常生活环境中的高频信号，提高高频信号比值，控制近视发展。</div>
            <div className="Argos_section3-contentItem">
              <div className='Argos_section3-contentItemBlock flex_row flex_ai-c'>
                <img
                  className='Argos_section3-itemIcon'
                  src='./images/argos/argos2_icon_white.png'
                  alt=''
                />
                <div className="Argos_section3-btnText">脑视觉训练</div>
              </div>
            </div>
            <div className="Argos_section3-itemDesc">中高频信号正常呈现，低频信息处理为视觉噪声，定向锻炼大脑对高频信号的感知能力。</div>
          </div>
          <div className="Argos_section3-topRight flex_col flex_jc-c">
            <img
              style={{ width: '100%' }}
              src='./images/argos/argos-img-2.png'
              alt=''
            />
          </div>
        </div>
        <div className="Argos_section3-content pageMargin">
          <div className="Argos_section3-contentBlock">
            <div className="Argos_section3-contentItem">
              <div className='Argos_section3-contentItemBlock flex_row flex_ai-c'>
                <img
                  className='Argos_section3-itemIcon'
                  src='./images/argos/argos1_icon_white.png'
                  alt=''
                />
                <div className="Argos_section3-btnText">高频增强</div>
              </div>
            </div>
            <div className="Argos_section3-contentBlockRight">
              <span className="Argos_section3-contentSubTitle linear-gradient-tr">有效增加脉络膜厚度</span>
              <div className="Argos_section3-itemDesc">强化日常生活环境中的高频信号，提高高频信号比值，控制近视发展。</div>
            </div>
          </div>
          <div className="Argos_section3-contentBlock1">
            <div className='Argos_section3-contentBlock1Left'>
              <div className="flex_row flex_ai-c">
                <img
                  className='Argos_section3-block1BottomLeftIcon'
                  src='./images/argos/time_icon_color.png'
                  alt=''
                />
                <span className='Argos_section3-contentSubTitle ml_8 linear-gradient-tr'>2小时训练</span>
              </div>
              <div className="Argos_section3-contentSubTitle1" >明亮条件下，<br />2小时总训练时长</div>
              <div className='Argos_section3-itemDesc'>
                强化2CPD以上空间频率信息，受试眼脉络膜平均增厚4.11㎛<br /><br />
                强化6CPD以上空间频率信息，受试眼脉络膜平均增厚6.11㎛
              </div>
            </div>
            <div className="Argos_section3-blockImg1 flex_col flex_jc-c">
              <img
                style={{ width: '100%' }}
                src='./images/argos/data1.png'
                alt=''
              />
            </div>
          </div>
        </div>
        <div className='Argos_section3-block2'>
          <div className="Argos_section3-block2Top pageMargin">
            <div className="Argos_section3-contentItem">
              <div className='Argos_section3-contentItemBlock flex_row flex_ai-c'>
                <img
                  className='Argos_section3-itemIcon'
                  src='./images/argos/argos2_icon_white.png'
                  alt=''
                />
                <div className="Argos_section3-btnText">脑视觉训练</div>
              </div>
            </div>
            <div className='Argos_section3-contentBlockRight'>
              <span className="Argos_section3-contentSubTitle linear-gradient-tr">快速提高视觉质量</span>
              <div className="Argos_section3-itemDesc">中高频信号正常呈现，低频信息处理为视觉噪声，定向锻炼大脑对高频信号的感知能力。</div>
            </div>
          </div>
          <div className='Argos_section3-block2Bottom'>
            <div className='Argos_section3-block2Left'>
              <div className='Argos_section3-block2LeftItem'>
                <div className='Argos_section3-block2LeftItemTop'>
                  <div className="flex_row flex_ai-c">
                    <img
                      className='Argos_section3-block1BottomLeftIcon'
                      src='./images/argos/time_icon_color.png'
                      alt=''
                    />
                    <span className='Argos_section3-contentSubTitle ml_8 linear-gradient-tr'>30分钟训练</span>
                  </div>
                  <div className='Argos_section3-contentSubTitle1 mt_22'>训练前后外周视野<br />对比敏感度(100%幅度噪声)</div>
                  <div className='Argos_section3-itemDesc'>30分钟的训练显著提高了参与者外周视野对于高空间频率信息的对比度敏感度﹙t(11) = 3.952, p = 0.004）</div>
                </div>
                <div className="Argos_section3-blockImg3">
                  <img
                    style={{ width: '100%' }}
                    src='./images/argos/30min-1.png'
                    alt=''
                  />
                </div>
              </div>
              <div className='Argos_section3-block2LeftItem'>
                <div className='Argos_section3-block2LeftItemTop'>
                  <div className="flex_row flex_ai-c">
                    <img
                      className='Argos_section3-block1BottomLeftIcon'
                      src='./images/argos/time_icon_color.png'
                      alt=''
                    />
                    <span className='Argos_section3-contentSubTitle ml_8 linear-gradient-tr'>30分钟训练</span>
                  </div>
                  <div className='Argos_section3-contentSubTitle1 mt_22'>训练前后外周视野<br />对比敏感度(30%幅度噪声)</div>
                  <div className='Argos_section3-itemDesc'>30分钟的训练显著提高了参与者外周视野的视锐度（训练组：t(11)=2.565,p=0.026），并且与对照组比较训练组的提高也是显著的（F(1,11) = 5.598, p = 0.037）</div>
                </div>
                <div className="Argos_section3-blockImg3">
                  <img
                    style={{ width: '100%' }}
                    src='./images/argos/30min-2.png'
                    alt=''
                  />
                </div>
              </div>
            </div>
            <div className="Argos_section3-blockImg2">
              <img
                style={{ width: '100%' }}
                src='./images/argos/argos(4).png'
                alt=''
              />
            </div>
          </div>
        </div>
      </div>
      <div className="Argos_section4">
        <div className='Argos_section4-block'>
          <div className='Argos_section4-top'>
            <div className='Argos_section4-title linear-gradient-tr'>一副眼镜，两种模式全方位近视防控</div>
            <div className='Argos_section4-desc'>
              {/* 搭载先进的AR技术，支持摄像头实时采集和多媒体传输两种模式。<br /><br /> */}
              搭载AR技术，支持摄像头实时采集和多媒体传输两种模式。<br /><br />
              两种训练模式均支持任意画面，轻松有趣、训练更简单!
            </div>
          </div>
          <div className="Argos_section4-img">
            <img
              style={{ width: '100%' }}
              src='./images/argos/argos-img-3.png'
              alt=''
            />
          </div>
        </div>
        {/* PC端 */}
        <div className="Argos_section4-content pageMargin">
          {/* <div className='mt_168 pb_100' style={{ width: '85%' }}> */}
          <div className='mt_168 pb_40' style={{ width: '85%' }}>
            <div className='flex_row flex_jc-c'>
              <img
                style={{ width: '70%' }}
                src='./images/argos/moshi-1080.png'
                alt=''
              />
            </div>
            <div className='flex_row gap_16 mt_26'>
              <div style={{ flex: 1 }} className='flex_col flex_ai-c'>
                <div style={{ maxHeight: '240px' }}>
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src='./images/argos/richang.png'
                    alt=''
                  />
                </div>
              </div>
              <div style={{ flex: 1 }} className='flex_col flex_ai-c'>
                <div style={{ maxHeight: '240px' }}>
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src='./images/argos/gaopin.png'
                    alt=''
                  />
                </div>
              </div>
              <div style={{ flex: 1 }} className='flex_col flex_ai-c' >
                <div style={{ maxHeight: '240px' }}>
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src='./images/argos/naoshijue.png'
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 移动端 */}
        <div className="Argos_section4-block1 flex_col gap_20 pageMargin pb_40">
          <div className='flex_col flex_ai-c gap_10'>
            <div className='fz_18 fw_700 lh_21 linear-gradient-tr' style={{ width: 'auto' }}>日常画面</div>
            <img
              className='bdr_12'
              style={{ width: '100%' }}
              src='./images/argos/richang.png'
              alt=''
            />
          </div>
          <div className='flex_col flex_ai-c gap_10'>
            <div className='fz_18 fw_700 lh_21 linear-gradient-tr' style={{ width: 'auto' }}>高频增强</div>
            <img
              className='bdr_12'
              style={{ width: '100%' }}
              src='./images/argos/gaopin.png'
              alt=''
            />
          </div>
          <div className='flex_col flex_ai-c gap_10'>
            <div className='fz_18 fw_700 lh_21 linear-gradient-tr' style={{ width: 'auto' }}>脑视觉训练</div>
            <img
              className='bdr_12'
              style={{ width: '100%' }}
              src='./images/argos/naoshijue.png'
              alt=''
            />
          </div>
        </div>
      </div>
      <div className="Arta_tip" style={{background: '#ffffff'}}>本产品仅限临床试验使用，须在专业医疗机构及研究人员指导下进行。</div>
      <Footer />
    </div>
  );
}

export default Argos;